import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './store';
import { CognitoUser } from '../interfaces/cognitoUser';

export interface UserSettingState {
    isGuest: boolean;
    activeUser?: string;
    temporaryUser?: CognitoUser;
    canUpdate: boolean;
}

const initialState: UserSettingState = {
    isGuest: false,
    activeUser: undefined,
    temporaryUser: undefined,
    canUpdate: false
};

export const userSettingsSlice = createSlice({
    name: 'userSettings',
    initialState,
    reducers: {
        changeIsGuest(state, action) {
            return {
                ...state,
                isGuest: action.payload
            };
        },
        setActiveUser(state, action) {
            return {
                ...state,
                activeUser: action.payload
            };
        },
        setTemporaryUser(state, action) {
            return {
                ...state,
                temporaryUser: action.payload
            };
        },
        setCanUpdate(state, action) {
            return {
                ...state,
                canUpdate: action.payload
            };
        }
    }
});

export const selectIsGuest = (state: RootState): boolean => {
    return state.userSettings.isGuest;
};

export const selectActiveUser = (state: RootState) => {
    return state.userSettings.activeUser;
};

export const selectTemporaryUser = (state: RootState) => {
    return state.userSettings.temporaryUser;
};

export const selectCanUpdate = (state: RootState) => {
    return state.userSettings.canUpdate;
};

export const { changeIsGuest, setActiveUser, setTemporaryUser, setCanUpdate } =
    userSettingsSlice.actions;

export default userSettingsSlice.reducer;
